import { render, staticRenderFns } from "./PaymentRequests.vue?vue&type=template&id=42550e3e"
import script from "./PaymentRequests.vue?vue&type=script&lang=js"
export * from "./PaymentRequests.vue?vue&type=script&lang=js"
import style0 from "./PaymentRequests.vue?vue&type=style&index=0&id=42550e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports